import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { storeSet } from '../../store';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import FileuploadIcon from '../../icons/FileuploadIcon';
import ButtonIconSimple from '../ButtonWrapper/components/ButtonIconSimple';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

const ModalUploadCueSheetClip = ({
                                     projectId,
                                     cueSheetItem
                                 }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            clip: null
        }
    });

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            // File import workflow: send only file
            const formDataToSend = new FormData();
            formDataToSend.append('file', formData.clip);
            await storeSet('createClipItem', projectId, formDataToSend, [
                ['projectId', projectId],
                ['clipType', cueSheetItem.cueType],
                ['cueSheetId', cueSheetItem.id]
            ]);

            handleSuccessAndDisplay(__('Clip è stato caricato con successo', 'soundbetween'))
            reset();
            setModalVisible(false);
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    }

    const handleCreateNew = () => {
        setModalVisible(true);
    }

    const handleCloseModal = () => {
        reset();
        setModalVisible(false);
    }

    return (
        <>
            <ButtonIconSimple
                onClick={handleCreateNew}>
                <FileuploadIcon/>
            </ButtonIconSimple>
            {modalVisible
                ? <ModalDialog
                    additionalClasses={['modalCreateProject']}
                    header={__('Carica clip', 'soundbetween')}
                    visible={modalVisible}
                    onSubmit={handleSubmit(onSubmit)}
                    onHide={handleCloseModal}>
                    <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                        <FormField
                            control={control}
                            name="clip"
                            label={__('Carica file', 'soundbetween')}
                            placeholder={__('Scegli un file', 'soundbetween')}
                            type="fileupload"
                            accept=".mp3"
                            rules={{
                                required: false
                            }}
                        />

                        <div className="appFormActions">
                            <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                                {__('Anulla', 'soundbetween')}
                            </ButtonFlat>
                            <ButtonFormSubmit disabled={loading || !isValid}>
                                {__('Salva', 'soundbetween')}
                            </ButtonFormSubmit>
                        </div>
                    </form>
                </ModalDialog> : null}
        </>
    )
}

export default ModalUploadCueSheetClip;